import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InsuranceRoutingModule } from './insurance-routing.module';
import { InsuranceComponent } from './insurance.component';
import { InsuranceProfileComponent } from './insurance-profile/insurance-profile.component';
import { InsuranceCoverageComponent } from './insurance-coverage/insurance-coverage.component';

import { InsuranceCarriersSubscribersModule } from './insurance-carriers-subscribers/insurance-carriers-subscribers.module';
import { InsuranceCreateCarrierModule } from './insurance-create-carrier/insurance-create-carrier.module';
import { InsuranceManageSubscribersModule } from './insurance-manage-subscribers/insurance-manage-subscribers.module';
import { InsuranceManagementModule } from './insurance-management/insurance-management.module';
import { InsuranceCoverageModule } from './insurance-coverage/insurance-coverage.module';
import { InsuranceProfileModule } from './insurance-profile/insurance-profile.module';
import { InsuranceRtbDialogComponent } from './insurance-rtb-dialog/insurance-rtb-dialog.component';
import {MatDialogModule} from '@angular/material/dialog';
import {TdoControlsModule} from '../../tdo-controls/tdo-controls.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { InsurancePayeridsComponent } from './insurance-payerids/insurance-payerids.component';
import { InsuranceCompanyPickerComponent } from './insurance-company-picker/insurance-company-picker.component';
import {MatIconModule} from '@angular/material/icon';
import { InsuranceNoFeeScheduleDialogComponent } from './insurance-no-fee-schedule-dialog/insurance-no-fee-schedule-dialog.component';
import { InsuranceCompanyManagerComponent } from './insurance-company-manager/insurance-company-manager.component';
import {ConfigurationModule} from '../configuration/configuration.module';
import { InsuranceRtbDialogPlanBenefitDetailsComponent } from './insurance-rtb-dialog-plan-benefit-details/insurance-rtb-dialog-plan-benefit-details.component';
import { InsuranceRtbDialogPlanDetailsComponent } from './insurance-rtb-dialog-plan-details/insurance-rtb-dialog-plan-details.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatOptionModule} from '@angular/material/core';
import {MatSelectModule} from '@angular/material/select';
import {FormsModule} from '@angular/forms';
import { InsuranceSelectFeeScheduleComponent } from './insurance-select-fee-schedule/insurance-select-fee-schedule.component';
import {MatListModule} from "@angular/material/list";
import {DevExtremeModule} from "devextreme-angular";
import { MatInputModule } from '@angular/material/input';
import { InsuranceDxCrossRefComponent } from './insurance-dx-cross-ref/insurance-dx-cross-ref.component';

// import { TdoSharedModule } from '../tdo-shared/tdo-shared.module';

@NgModule({
  declarations: [
    InsuranceComponent,
    InsuranceRtbDialogComponent,
    InsurancePayeridsComponent,
    InsuranceCompanyPickerComponent,
    InsuranceNoFeeScheduleDialogComponent,
    InsuranceCompanyManagerComponent,
    InsuranceRtbDialogPlanBenefitDetailsComponent,
    InsuranceRtbDialogPlanDetailsComponent,
    InsuranceSelectFeeScheduleComponent,
    InsuranceDxCrossRefComponent,
  ],
    imports: [
        CommonModule,
        InsuranceRoutingModule,

        InsuranceCarriersSubscribersModule,
        InsuranceCreateCarrierModule,
        InsuranceManageSubscribersModule,
        InsuranceManagementModule,
        InsuranceCoverageModule,
        InsuranceProfileModule,
        MatDialogModule,
        TdoControlsModule,
        MatProgressSpinnerModule,
        MatIconModule,
        ConfigurationModule,
        MatFormFieldModule,
        MatOptionModule,
        MatSelectModule,
        FormsModule,
        MatListModule,
        DevExtremeModule,
        MatInputModule 

        // TdoSharedModule,
    ],
})
export class InsuranceModule { }
